import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MoreHorizontal } from "lucide-react";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import "./SellerProfile.css";
import CompanyAvatar from "../../UILibrary/CompanyAvatar";
import Reviews from "./Reviews";
import PreviewPopup from "../../UILibrary/FilePreviewPopup/PreviewPopup";
import Overlay from "../../UILibrary/Overlay";
const UserProfileComponent = ({
  onClose,
  backUrl,
  management,
  jobsAndOffers,
}) => {
  const [selectedTab, setSelectedTab] = useState("about");
  const userProfileRef = useRef(null);
  const [isFullProfileOpen, setIsFullProfileOpen] = useState(false);
  const [showCertificates, setShowCertificates] = useState(true);
  const [isPreview, setPreview] = useState(false);
  const supplier = useSelector((state) => state.auth.selectedSupplier);

  const contacts = supplier?.contact?.type || [];

  const getIcon = (name) => {
    switch (name) {
      case "Facebook":
        return <FaFacebook className="text-black" />;
      case "Instagram":
        return <FaInstagram className="text-black" />;
      case "LinkedIn":
        return <FaLinkedin className="text-black" />;
      case "Twitter":
        return <FaTwitter className="text-black" />;
      default:
        return null;
    }
  };

  const [copied, setCopied] = useState(null);

  const handleCopy = (url) => {
    navigator.clipboard.writeText(url);
    setCopied(url);
    setTimeout(() => setCopied(null), 2000);
  };

  const mainContact = contacts.find(
    (contact) => contact.identifier === "primary"
  );
  const otherContacts = contacts.filter(
    (contact) => contact.identifier !== "primary"
  );
  const navigate = useNavigate();

  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [previewItem, setPreviewItem] = useState(null);

  const handleDownload = (item) => {
    const blob = new Blob([JSON.stringify(item, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${item?.classification || "certificate"}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleOpenFullProfile = () => {
    setIsFullProfileOpen(!isFullProfileOpen);
    const navigateUrl = management
      ? "/dashboard/management/supplier-profile-and-engagement"
      : jobsAndOffers
      ? "/seller-dashboard/jobs-and-offers/browse-enterprises/full-profile"
      : "/dashboard/marketplace/full-profile";

    navigate(navigateUrl, {
      state: { supplier, backUrl, management },
    });
  };

  const handleMessage = () => {
    navigate("/buyer-dashboard/collaborations", {
      state: { supplier, backUrl },
    });
  };
  const handleTabClick = (tab) => {
    if (tab !== "about") setShowCertificates(false);
    else {
      setShowCertificates(true);
    }
    setSelectedTab(tab);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userProfileRef.current &&
        !userProfileRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const divFlexRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };
  const divFlexColumn = {
    display: "flex",
    flexDirection: "column",
  };
  const tabStyle = {
    padding: "10px",
    cursor: "pointer",
  };

  const activeTabStyle = {
    color: "#1D2739",
    borderRadius: "8px",
    background: "#F0F2F4",
    fontSize: "14px",
    padding: "8px",
    whiteSpace: "nowrap",
  };

  const inactiveTabStyle = {
    color: "#7B7B7B",
    fontSize: "14px",
    whiteSpace: "nowrap",
  };

  const generateInfoBox = (label, value) => {
    return (
      <div className="info-box">
        <p
          style={{
            color: "grey",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {label} <span style={{ color: "black" }}>{value}</span>
        </p>
      </div>
    );
  };

  return (
    <div>
      <div ref={userProfileRef} className="user-profile-card-body">
        <div
          style={{
            ...divFlexRow,
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={divFlexRow}>
            <div style={{ marginRight: "10px" }}>
              <CompanyAvatar
                companyName={supplier?.company?.name || ""}
                size="38px"
              />
            </div>

            <span className="user-profile-subtitle">
              {supplier?.company?.name}
            </span>
          </div>

          <div style={{ ...divFlexRow, alignItems: "center", gap: "10px" }}>
            <button
              type="submit"
              className="h-9 px-[10px] rounded-lg border-none text-black flex items-center text-center bg-[#EAF524]"
              onClick={handleMessage}
            >
              Message
            </button>
            <button
              onClick={() => handleOpenFullProfile()}
              className="h-9 rounded-lg border-none text-black flex items-center text-center bg-[#F1F1F1] whitespace-nowrap px-4"
            >
              Full Profile
            </button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "42px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                color: "#9A9A9A",
                marginRight: "10px",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              {supplier?.industry?.name}
            </p>
            <p
              style={{
                color: "#9A9A9A",
                marginRight: "10px",
                textAlign: "left",
                fontSize: "16px",
              }}
            >
              {(() => {
                const location = supplier?.address?.type?.[0];
                if (!location) return "";

                const parts = [
                  location.city,
                  location.state,
                  location.country,
                ].filter(Boolean);
                return parts.join(", ");
              })()}
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ color: "#7B7B7B" }}>Rating:</p>
            <span className="supplier-rating">
              <p>{"No rating yet"}</p>
            </span>
            {supplier?.diversity?.certificationType?.length > 0 && (
              <span className="flex items-center justify-center">
                <svg
                  className="ml-4 mr-1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_180_62016)">
                    <mask
                      id="mask0_180_62016"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M8.00066 14.6663C8.87629 14.6674 9.74351 14.4955 10.5525 14.1604C11.3615 13.8253 12.0963 13.3336 12.7147 12.7137C13.3346 12.0953 13.8263 11.3605 14.1614 10.5515C14.4965 9.74254 14.6684 8.87532 14.6673 7.99968C14.6684 7.12404 14.4965 6.25682 14.1614 5.44784C13.8263 4.63886 13.3346 3.90407 12.7147 3.28568C12.0963 2.66573 11.3615 2.17409 10.5525 1.83898C9.74351 1.50388 8.87629 1.33193 8.00066 1.33301C7.12502 1.33193 6.2578 1.50388 5.44882 1.83898C4.63984 2.17409 3.90505 2.66573 3.28666 3.28568C2.66671 3.90407 2.17506 4.63886 1.83996 5.44784C1.50486 6.25682 1.33291 7.12404 1.33399 7.99968C1.33291 8.87532 1.50486 9.74254 1.83996 10.5515C2.17506 11.3605 2.66671 12.0953 3.28666 12.7137C3.90505 13.3336 4.63984 13.8253 5.44882 14.1604C6.2578 14.4955 7.12502 14.6674 8.00066 14.6663Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.33333"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.33398 8L7.33398 10L11.334 6"
                        stroke="black"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </mask>
                    <g mask="url(#mask0_180_62016)">
                      <path
                        d="M0.000976562 0H16.001V16H0.000976562V0Z"
                        fill="#0088FF"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_180_62016">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.000976562)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p className="text-blue-500 text-sm">Certified</p>
              </span>
            )}
          </div>
        </div>
        <span className="text-[#1D2739] text-base font-bold flex mb-2">
          Contacts
        </span>
        <div className="rounded-[17.299px] w-[460px] border-[1.081px] border-[#EBEBEB] bg-white p-6">
          {mainContact && (
            <>
              <span className="main-contact-subtitle flex text-left text-base">
                Main Contact
              </span>
              <div style={{ ...divFlexRow, marginTop: "16px" }}>
                <div style={{ marginRight: "10px" }}>
                  <div className="w-8 h-8 rounded-full border-4 border-[#B5B5B5] bg-[#D9D9D9]"></div>
                </div>
                <div style={{ ...divFlexColumn, alignItems: "flex-start" }}>
                  <span className="text-black text-base">{`${mainContact.name.firstName} ${mainContact.name.lastName}`}</span>
                  <span className="text-[#7B7B7B] text-sm">
                    {mainContact?.Salutation}
                  </span>
                </div>
              </div>
            </>
          )}

          {otherContacts.length > 0 && (
            <>
              <span className="main-contact-subtitle flex mt-4 mb-4 text-base">
                Other Contacts
              </span>
              {otherContacts.map((contact, index) => (
                <div key={index} style={{ ...divFlexRow, marginTop: "16px" }}>
                  <div style={{ marginRight: "10px" }}>
                    <div className="w-8 h-8 rounded-full border-4 border-[#B5B5B5] bg-[#D9D9D9]"></div>
                  </div>
                  <div style={{ ...divFlexColumn, alignItems: "flex-start" }}>
                    <span className="text-black text-base">{`${contact.name.firstName} ${contact.name.lastName}`}</span>
                    <span style={{ color: "#7B7B7B" }}>
                      {contact?.Salutation}
                    </span>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>

        <div className="company-info-container">
          <span className="flex text-base font-semibold text-black mb-4">
            Company info
          </span>
          <div className="info-boxes">
            {generateInfoBox("Industry", supplier?.industry.name)}
            {generateInfoBox(
              "Employees",
              supplier?.company?.employeeRange?.min &&
                supplier?.company?.employeeRange?.max
                ? `${supplier.company.employeeRange.min} - ${supplier.company.employeeRange.max}`
                : "N/A"
            )}
          </div>
        </div>
        <div className="tabs" style={divFlexRow}>
          <div
            className="tab"
            style={{
              ...tabStyle,
              ...(selectedTab === "about" ? activeTabStyle : inactiveTabStyle),
            }}
            onClick={() => handleTabClick("about")}
          >
            Company Details
          </div>
          <div
            className="tab"
            style={{
              ...tabStyle,
              ...(selectedTab === "capabilities"
                ? activeTabStyle
                : inactiveTabStyle),
            }}
            onClick={() => handleTabClick("capabilities")}
          >
            Capabilities
          </div>
          <div
            className="tab"
            style={{
              ...tabStyle,
              ...(selectedTab === "certifications"
                ? activeTabStyle
                : inactiveTabStyle),
            }}
            onClick={() => handleTabClick("certifications")}
          >
            Certifications
          </div>
          <div
            className="tab"
            style={{
              ...tabStyle,
              ...(selectedTab === "identifiers"
                ? activeTabStyle
                : inactiveTabStyle),
            }}
            onClick={() => handleTabClick("identifiers")}
          >
            Identifiers
          </div>
          <div
            className="tab"
            style={{
              ...tabStyle,
              ...(selectedTab === "reviews"
                ? activeTabStyle
                : inactiveTabStyle),
            }}
            onClick={() => handleTabClick("reviews")}
          >
            Reviews
          </div>
        </div>

        <div className="tab-content">
          {selectedTab === "about" && (
            <>
              <p className="text-[#7B7B7B] font-lato text-sm font-normal leading-[20px]">
                {supplier?.company?.description ||
                  supplier?.capability?.capabilityDetails?.[0]?.description}
              </p>

              <div className="flex flex-col justify-start items-start mt-12">
                <span className="text-[#1D2739] text-base font-bold flex mb-2">
                  Website
                </span>
                <span className="text-[#7B7B7B] text-sm border rounded p-4">
                  {supplier?.company?.website}
                </span>
              </div>

              <div className="flex flex-col justify-start items-start mt-8">
                <span className="text-[#1D2739] text-base font-bold flex mb-2">
                  Address
                </span>

                {supplier?.address?.type?.map((addr, index) => (
                  <div className="border rounded mb-6">
                    <span className="text-sm text-[#1D2739] mt-4 mb-6 font-semibold flex justify-start items-start pl-2">
                      Address {index + 1}
                    </span>
                    <table
                      key={index}
                      className="w-full border-collapse table-fixed"
                    >
                      <thead className="text-[#7B7B7B] text-sm whitespace-nowrap">
                        <tr>
                          <th className="text-center px-2 py-4 text-[#7B7B7B] text-sm ">
                            <span className="flex items-center gap-[1px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_180_45159)">
                                  <path
                                    d="M1.02012 1.91992C0.914031 1.91992 0.812289 1.96206 0.737274 2.03708C0.66226 2.11209 0.620117 2.21384 0.620117 2.31992V13.6799C0.620117 13.786 0.66226 13.8877 0.737274 13.9628C0.812289 14.0378 0.914031 14.0799 1.02012 14.0799H11.7209C11.5813 13.8958 11.4413 13.7118 11.3011 13.5279C11.1264 13.2702 10.8726 13.0495 10.7982 12.7362C9.7694 13.1609 8.58732 13.2002 7.53164 12.8478C7.50844 12.8402 7.48572 12.831 7.46268 12.8231C7.34156 12.9415 7.211 13.1479 7.19036 13.2799H5.66924C5.78348 12.8929 5.54092 12.2886 5.77036 11.8946C5.7886 11.8898 5.81068 11.859 5.82076 11.8271C5.79484 11.8028 5.7686 11.7791 5.74332 11.7543C5.51836 11.8228 5.42844 11.9922 5.30332 12.1409C5.37164 12.4647 4.87852 12.3881 4.92828 12.7185C5.2718 12.9849 4.61116 12.7818 4.41468 12.8031C4.2062 12.8054 3.59628 12.5871 3.80796 13.0335C3.77484 13.1561 3.8054 13.2313 3.86636 13.2799H3.77292C3.75836 13.1398 3.49436 13.119 3.3926 13.0502C3.22124 13.0086 3.0166 12.9878 2.83916 12.9087C2.79356 13.0354 2.38204 13.1804 2.29196 13.2799H1.42012V7.43496C1.54284 7.5172 1.81804 7.48456 1.443 7.30696H1.42012V5.46472C1.49292 5.42792 1.54492 5.41624 1.54172 5.47784C1.72204 5.41704 1.8006 4.97816 2.1126 5.15784C2.30716 5.18648 2.62908 5.48808 2.46732 5.52584C2.5934 5.83368 2.68284 5.63544 2.83756 6.00232C2.73164 6.50408 3.13724 6.87592 3.3598 7.19576C3.62636 7.30648 3.7318 7.65112 4.16508 7.66456C4.22396 7.71608 4.29948 7.7628 4.3782 7.8076C4.39996 7.64206 4.4302 7.47811 4.46892 7.31576C4.45852 7.31336 4.44844 7.31192 4.43724 7.30824C4.02044 7.69272 3.935 7.02712 4.34204 7.00104C4.36924 6.99934 4.39857 7.00067 4.43004 7.00504C4.47724 6.99944 4.51644 7.00504 4.54956 7.01672C4.68323 6.57852 4.88129 6.16262 5.13724 5.78264C5.27481 5.57762 5.42909 5.38432 5.59852 5.20472C5.51436 5.06392 5.42828 4.98536 5.32668 5.1692C5.319 4.8964 4.5814 4.61048 5.12412 4.87224C5.40876 5.11752 5.50204 4.82968 5.547 4.6332C5.791 4.3788 5.29692 4.29192 5.387 4.12568C5.23724 3.9012 5.01548 3.67128 4.78764 3.53224C4.34572 3.58344 4.19084 3.49016 4.78172 3.48984C4.835 3.21384 4.92348 3.01832 4.98444 2.786C4.92044 2.7676 4.85356 2.77048 4.78764 2.77032C4.50492 2.7324 4.33708 2.84168 4.34284 3.05752C4.13052 3.04056 4.32124 2.67864 3.99388 2.7892C3.49756 2.78136 4.09756 2.94904 4.05148 2.9732C3.99468 3.10056 3.63708 3.0212 3.67916 3.15032C3.51532 2.84728 3.44076 3.2948 3.31324 2.98824C3.23644 2.91464 3.63484 3.06088 3.54412 2.79256C3.34348 2.71576 3.27164 2.85016 3.11532 2.90504C2.64876 3.16328 3.19676 3.40616 3.43372 3.49224C3.79084 3.39704 3.79052 3.27672 4.03884 3.40904C4.31724 3.56344 3.75772 3.45496 3.77484 3.69256C3.74284 3.54488 3.70284 3.45576 3.53004 3.64504C3.29964 3.68664 3.19676 3.37 3.02476 3.39224C2.63276 3.33896 2.77916 4.22056 3.10204 3.9204C3.2974 4.25848 2.85244 4.00904 2.72044 3.97128C2.42236 4.30424 2.10124 3.96264 1.7454 3.94888C1.63148 3.87304 1.5198 3.87208 1.42012 3.91064V2.71992H5.6158C5.3166 2.72808 5.0494 2.7676 5.1582 2.9828C5.1406 3.39784 5.67756 3.06824 5.75484 3.4436C5.97788 3.70584 5.6222 4.26344 6.00796 4.16552C5.86604 4.33816 5.8838 4.6132 5.99452 4.83C6.40412 4.48626 6.86863 4.21388 7.3686 4.02424C7.3774 3.97496 7.37052 3.91832 7.34108 3.85144C7.291 3.6004 7.52396 3.52024 7.44236 3.24184C7.55212 3.03224 7.467 2.81048 7.27884 2.71992H15.9801V3.8524C15.9553 3.84184 15.9298 3.83286 15.9038 3.82552C15.6784 4.02984 15.8606 4.0492 15.9801 4.00328V4.18184C15.7136 4.03192 15.4208 4.01544 15.1364 4.07784C15.0073 3.85336 14.5502 3.85864 14.3998 3.65656C14.1348 3.33912 14.4806 3.43384 14.7118 3.40936C14.6462 3.21096 14.2526 3.11688 14.0864 3.14968C13.786 3.31416 14.2441 3.46168 14.1979 3.68248C14.1979 3.84296 14.0022 3.84408 13.8315 3.83528C13.9004 3.66536 13.5046 3.4564 13.3476 3.59464C13.0505 3.50472 12.9372 3.55752 13.1332 3.24808C13.0648 3.01016 12.7817 3.00568 12.6548 2.84056C12.4928 3.18424 12.2225 3.08008 11.9329 3.28936C11.8169 3.45896 11.5753 3.61128 11.5633 3.72328C11.3838 3.8076 11.2041 3.37736 11.0782 3.75848C10.964 4.08104 11.0846 4.23736 10.6992 3.97336C10.3003 3.54824 11.5004 3.18408 11.0544 3.00312C10.6841 3.11112 10.4616 3.37208 10.388 3.7428C10.3481 3.82712 10.3662 3.88584 10.4083 3.93336C11.8137 4.35256 12.9768 5.4828 13.4496 6.86936C13.4569 6.78584 13.4708 6.70552 13.4988 6.6468C13.6171 6.55656 13.5233 6.9932 13.7676 6.74488C13.5876 7.13128 14.2201 6.79608 14.3057 6.63656C14.1803 6.32168 14.7569 6.17336 14.7435 6.114C14.5312 5.89128 14.6518 6.11288 14.4176 6.16392C14.34 6.06056 14.5664 5.49384 14.2651 5.54584C13.8152 5.43 14.6478 5.09864 14.8726 5.22056C14.975 4.84168 15.1222 5.14344 14.8692 5.31768C14.7729 5.65384 14.819 6.1124 15.1024 5.66312C15.2297 5.53912 15.198 5.21592 15.3638 5.1596C15.5865 5.05464 15.984 4.97256 15.9736 4.64808C15.9758 4.64744 15.9779 4.6476 15.9801 4.64712V13.2799H15.3467C15.484 13.0898 15.6656 12.7647 15.4732 12.6468C15.1835 12.5967 14.967 12.2473 14.6168 12.2618C14.4587 12.0798 14.0947 11.9876 13.9968 11.9521C13.8988 11.9166 13.7289 12.1218 13.5548 12.0311C13.5024 12.0227 13.449 12.0237 13.3969 12.034C13.9208 12.714 14.4396 13.3977 14.9604 14.0799H16.3801C16.4862 14.0799 16.5879 14.0378 16.663 13.9628C16.738 13.8877 16.7801 13.786 16.7801 13.6799V2.31992C16.7801 2.21384 16.738 2.11209 16.663 2.03708C16.5879 1.96206 16.4862 1.91992 16.3801 1.91992H1.02012ZM8.81052 2.77112C8.55292 2.898 9.00972 3.40312 9.02236 2.92088C9.06956 2.99128 9.3862 3.06232 9.28268 2.83528C9.0526 2.69976 9.08748 2.8556 8.81036 2.77128M12.5033 2.7716C12.2254 2.90696 12.7465 2.90952 12.5033 2.7716V2.7716ZM3.67452 2.81752C3.46652 2.97208 3.9798 3.12504 3.70172 2.82568L3.67452 2.81752ZM5.37772 2.9092C5.32636 2.94136 5.42972 2.95912 5.37772 2.9092V2.9092ZM3.36892 3.1068C3.35612 3.10888 3.3934 3.13512 3.36892 3.1068V3.1068ZM4.0814 3.17272C4.0622 3.27512 4.33212 3.21624 4.0814 3.17272V3.17272ZM4.4326 3.20152C4.52012 3.26072 4.671 3.18632 4.4326 3.20152V3.20152ZM3.7326 3.21208C3.71276 3.28392 3.88764 3.22808 3.7326 3.21208V3.21208ZM4.22892 3.43736C4.1518 3.48616 4.38572 3.47352 4.22892 3.43736V3.43736ZM4.33948 3.6868C4.24508 3.98792 4.675 4.3956 4.3414 4.0524C4.24972 3.91512 4.20204 3.7836 4.33948 3.6868ZM3.7798 3.7172C3.91724 3.9468 4.12652 4.00808 3.95132 4.08712C3.835 4.0308 3.80812 3.85544 3.7798 3.7172ZM5.93644 3.94856C5.88428 3.95176 5.9558 3.96152 5.93644 3.94856V3.94856ZM2.69228 4.02104C2.66748 4.02216 2.67436 4.09368 2.69228 4.02104V4.02104ZM3.93132 4.13848C3.8582 4.13576 3.92012 4.28984 3.93132 4.13848V4.13848ZM4.851 4.13944C4.79116 4.43544 5.0286 4.41656 5.0126 4.44632C4.81644 4.53272 4.86332 4.88856 4.71324 4.61704C4.61852 4.57288 4.76188 4.18216 4.82636 4.14792L4.851 4.13944ZM3.88668 4.13976C3.88524 4.20904 3.90764 4.14456 3.88668 4.13976V4.13976ZM15.4604 4.16632C15.4326 4.19352 15.4668 4.1772 15.4604 4.16632V4.16632ZM3.8982 4.20504C3.75196 4.30904 4.00732 4.31928 3.8982 4.20504V4.20504ZM8.98268 4.36232C8.11019 4.36843 7.26331 4.65784 6.56956 5.18696C4.79516 6.53816 4.44988 9.08536 5.80108 10.8598C7.06588 12.5207 9.37548 12.9214 11.1211 11.8578L11.4545 12.2958C11.3889 12.4484 11.395 12.5943 11.4713 12.6948L13.8905 15.8716C14.0345 16.0606 14.3822 16.038 14.667 15.821C14.9518 15.6042 15.0659 15.2751 14.922 15.086L12.5028 11.9092C12.4264 11.8087 12.2873 11.7639 12.1227 11.7866L11.7892 11.3489C13.2787 9.94888 13.507 7.61608 12.2424 5.95512C11.5667 5.06792 10.592 4.53832 9.56444 4.39912C9.37164 4.373 9.17723 4.3607 8.98268 4.36232ZM4.44044 4.7636C4.54044 5.00104 4.92668 4.86168 4.77548 5.18536C4.9438 5.34376 4.74876 5.90216 4.68332 5.42632C4.26444 5.42424 4.06444 5.00632 4.41612 4.78696L4.44044 4.7636ZM4.8054 4.80296C4.6038 4.8636 4.9334 4.91176 4.8054 4.80296V4.80296ZM14.8579 5.09544C14.8691 5.08744 14.8969 5.14488 14.8579 5.09544V5.09544ZM9.1438 5.2588C9.2446 5.26275 9.34486 5.27139 9.4446 5.28472C9.85464 5.34014 10.2497 5.47607 10.607 5.68471C10.9643 5.89334 11.2769 6.17055 11.5267 6.5004C11.778 6.829 11.962 7.204 12.068 7.60388C12.174 8.00375 12.2 8.42064 12.1445 8.83059C12.089 9.24055 11.9531 9.6355 11.7445 9.99278C11.536 10.3501 11.2589 10.6626 10.9292 10.9126C10.6006 11.1639 10.2256 11.3479 9.82573 11.4539C9.42584 11.56 9.00893 11.586 8.59896 11.5305C8.18899 11.475 7.79401 11.339 7.43672 11.1305C7.07942 10.9219 6.76684 10.6448 6.51692 10.3151C6.26559 9.98652 6.08164 9.61151 5.97562 9.21162C5.86961 8.81174 5.84362 8.39485 5.89915 7.9849C5.95467 7.57494 6.09062 7.17999 6.29919 6.82271C6.50775 6.46544 6.78483 6.15287 7.11452 5.90296C7.69513 5.45817 8.41295 5.23031 9.1438 5.2588ZM15.3179 5.4236C15.0667 5.63144 15.6195 5.59336 15.3179 5.4236V5.4236ZM15.6171 5.59672C15.339 5.73256 15.8601 5.73272 15.6171 5.59672V5.59672ZM15.7982 5.66008C15.5502 5.86648 16.051 5.758 15.7982 5.66008V5.66008ZM15.7883 5.70488C15.7798 5.71944 15.802 5.70472 15.7883 5.70488V5.70488ZM15.812 5.73064C15.792 5.7332 15.8195 5.7428 15.812 5.73064V5.73064ZM9.03772 5.89752C8.68796 5.89128 8.34268 5.96952 8.02428 6.11C8.04092 6.13032 8.06476 6.14984 8.09964 6.16744C7.77964 6.06344 7.68652 6.46776 7.82124 6.64968L8.03772 6.66744L8.21868 6.58776C8.33564 6.46616 8.36476 6.48712 8.40252 6.30296L8.47308 6.31208L8.52908 6.28872L8.6566 6.35176C8.80956 6.4116 8.81676 6.54056 8.76556 6.57832C8.69308 6.62296 8.77852 6.62952 8.78556 6.6572C8.82172 6.6468 8.84284 6.6156 8.86556 6.59896L8.90652 6.58424C9.05596 6.48616 8.95164 6.45384 8.8478 6.32152L8.90284 6.3356C8.98332 6.4268 9.03068 6.53 9.07836 6.6396C9.0838 6.64392 9.08876 6.64952 9.095 6.65144C9.13116 6.66344 9.1822 6.65944 9.22588 6.64744C9.26908 6.6356 9.27196 6.5532 9.2646 6.47432C9.3262 6.75528 9.93036 6.67176 9.57084 6.84312C9.36364 6.84776 9.03436 6.73416 8.97372 6.87768C8.83964 6.81688 8.77116 6.77704 8.74396 6.74584C8.6614 6.7148 8.4238 6.62488 8.41532 6.62488C8.40524 6.62488 8.10284 6.67992 8.10284 6.67992L7.85324 6.77464C7.77212 7.03608 7.64412 6.89624 7.6006 7.09896C7.56652 7.22856 7.27324 7.50856 7.42684 7.72904C7.56396 8.3668 8.359 7.94216 8.54428 8.2484C8.45724 8.43704 8.8878 8.79592 8.64684 9.10488C8.76044 9.55368 9.06572 10.3039 9.55692 9.6652C9.68652 9.2828 9.96556 9.07608 9.95564 8.69672C9.80732 8.32312 10.6804 8.04616 10.3312 7.7436C10.2475 7.75352 10.2379 7.7716 10.1715 7.79368C10.032 7.7884 9.99596 7.67592 9.94844 7.6052C9.91215 7.55361 9.88005 7.49919 9.85244 7.44248C9.94124 7.58008 10.0329 7.69688 10.1616 7.76872C10.3841 7.7188 10.6393 7.55416 10.7432 7.43336C10.7406 6.96248 11.3736 7.45096 11.3608 7.80488C11.4 7.90024 11.4497 7.96648 11.4996 8.0052C11.4643 7.77882 11.3967 7.55867 11.299 7.35144C11.1216 6.962 10.8374 6.6276 10.4921 6.37736C10.4857 6.38728 10.4697 6.38792 10.4729 6.36392C10.4262 6.33086 10.3785 6.29934 10.3297 6.26936C10.3351 6.29165 10.3414 6.31421 10.3488 6.33704C10.3278 6.30584 10.3057 6.27416 10.2875 6.2436C9.91052 6.02152 9.4782 5.89416 9.03788 5.89736L9.03772 5.89752ZM14.2436 5.91864C14.3596 6.2492 13.8401 7.01528 13.7646 6.5124C13.8179 6.26376 14.2443 6.3012 14.2436 5.91864ZM4.50364 6.006C4.49996 6.018 4.527 6.00328 4.50364 6.006V6.006ZM4.7502 6.12232C4.69388 6.15144 4.79676 6.16104 4.7502 6.12232V6.12232ZM9.55468 6.13288C9.6838 6.24168 10.08 6.38568 9.6606 6.2708C9.44236 6.37048 9.37484 6.30664 9.55468 6.13288ZM8.5566 6.32648C8.52844 6.33512 8.55228 6.39352 8.53468 6.41192C8.65468 6.47064 8.58748 6.3564 8.60524 6.33768C8.58092 6.32616 8.56588 6.32344 8.5566 6.32648ZM10.3859 6.44568C10.423 6.54216 10.4476 6.60376 10.3523 6.48408C10.3602 6.48033 10.3673 6.47498 10.3731 6.46838C10.3788 6.46177 10.3832 6.45404 10.3859 6.44568ZM8.5678 6.45768C8.52076 6.45256 8.4958 6.48408 8.49564 6.52808C8.61964 6.59544 8.60684 6.48424 8.62204 6.47576C8.60514 6.46651 8.58687 6.46038 8.5678 6.45768ZM10.4835 7.14296C10.5542 7.14584 10.4158 7.24536 10.4395 7.14856C10.4592 7.14424 10.4734 7.14248 10.4835 7.14296ZM15.3572 7.76888C15.1268 8.01368 15.6318 8.05672 15.3572 7.76888V7.76888ZM15.3412 7.80696C15.3369 7.82328 15.3649 7.8044 15.3412 7.80696V7.80696ZM15.3611 7.842C15.3371 7.838 15.3633 7.85848 15.3611 7.842V7.842ZM15.5286 7.874C15.3054 8.06824 15.798 7.99752 15.5286 7.874V7.874ZM15.5526 7.9292C15.5494 7.95272 15.5696 7.92632 15.5526 7.9292V7.9292ZM15.5211 7.93768C15.5081 7.94888 15.5358 7.95752 15.5211 7.93768V7.93768ZM13.6976 8.1892C13.7015 8.28904 13.7024 8.38878 13.7001 8.4884C13.8836 8.51768 14.1136 8.50936 14.1179 8.7124C14.4468 8.72664 14.084 9.20712 14.072 8.76232C13.9379 8.74302 13.8012 8.76619 13.6811 8.82856C13.6478 9.17772 13.5763 9.52218 13.468 9.85576C13.7368 9.77048 14.011 9.7788 14.1729 10.0401C14.5993 10.0385 14.2366 10.3292 14.5388 10.3886C14.6676 10.1255 14.471 10.1586 14.7126 9.94424C14.947 9.64456 14.7936 9.25752 14.5598 9.09384C14.5112 8.90856 14.3174 8.8084 14.4086 8.682C14.5862 8.9228 14.8379 8.74248 14.6278 8.61224C14.7828 8.46744 15.3368 8.98536 15.0257 8.58696C14.8721 8.55848 14.6611 8.24088 14.6132 8.44536C14.5995 8.61496 14.1763 8.18792 14.0201 8.36264C13.975 8.2052 13.7542 8.30024 13.7417 8.37048C13.8096 8.26488 13.7668 8.21032 13.6976 8.1892ZM14.5116 8.326C14.2824 8.45624 14.7187 8.45176 14.5116 8.326V8.326ZM8.52204 8.3372C8.51676 8.34408 8.54044 8.3788 8.52204 8.3372V8.3372ZM6.51356 8.35672C6.50875 8.5789 6.53345 8.80072 6.587 9.0164C6.771 8.73768 6.7638 8.47592 6.51356 8.35672ZM14.4998 8.3644C14.4828 8.36824 14.5136 8.37432 14.4998 8.3644V8.3644ZM14.6548 8.3836C14.58 8.4364 14.7296 8.4364 14.6548 8.3836V8.3836ZM14.6548 8.3852C14.5867 8.43416 14.7228 8.43416 14.6548 8.3852V8.3852ZM14.5152 8.39912C14.4915 8.39624 14.5177 8.41528 14.5152 8.39912V8.39912ZM13.6988 8.57288C13.6972 8.61128 13.6939 8.64968 13.6913 8.68808C13.743 8.62984 13.7654 8.56968 13.6988 8.57288ZM10.0521 8.73864C9.86716 8.84024 10.25 8.88664 10.09 8.76744L10.0832 8.75032L10.0521 8.73864ZM10.2684 8.76712C10.0857 8.88136 9.8022 9.426 10.1953 9.44312C10.29 9.33048 10.5302 8.82824 10.2684 8.76712ZM15.2246 9.114C15.0782 9.4028 15.6497 9.28728 15.2246 9.114V9.114ZM10.5612 9.1524C10.3235 9.31192 10.7918 9.29176 10.5612 9.1524V9.1524ZM15.6062 9.81096C15.7416 10.1174 15.2926 10.3009 15.3265 10.5854C15.5569 10.6964 15.6758 10.2785 15.838 10.1506C16.0299 9.98296 15.687 9.93336 15.6062 9.81096ZM4.96492 10.7534C4.99116 10.922 5.0702 11.0852 5.21132 11.135C5.123 11.0119 5.04077 10.8845 4.96492 10.7534Z"
                                    fill="#7B7B7B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_180_45159">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(0.700195)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#7B7B7B] text-sm"></span>
                              Country
                            </span>
                          </th>
                          <th className="text-center px-2 py-4 text-[#7B7B7B] text-sm ">
                            <span className="flex items-center gap-[1px] text-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_180_45169)">
                                  <path
                                    d="M15.2669 14.6676H1.93359M9.93359 6.00096H7.26693M9.93359 10.001H7.26693M4.93426 5.3343H4.92826M4.93493 8.00096H4.92826M4.93493 10.6676H4.92826M12.2676 5.3343H12.2616M12.2683 8.00096H12.2616M12.2683 10.6676H12.2616M14.6003 4.99096C14.6003 4.25896 14.6003 3.89363 14.4163 3.5843C14.2323 3.27496 13.8929 3.07363 13.2149 2.66763L12.3523 2.15163C11.2876 1.5143 10.7549 1.19563 10.3443 1.39296C9.93359 1.5903 9.93359 2.1643 9.93359 3.3123V14.6676H14.6003V4.99096ZM2.60026 4.99096C2.60026 4.25896 2.60026 3.89363 2.78426 3.5843C2.96826 3.27496 3.30759 3.07363 3.98559 2.66763L4.84826 2.15163C5.91359 1.51363 6.44559 1.1943 6.85626 1.3923C7.26693 1.5903 7.26693 2.1643 7.26693 3.3123V14.6676H2.60026V4.99096Z"
                                    stroke="#7B7B7B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_180_45169">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(0.600098)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#7B7B7B] text-sm"></span>
                              State
                            </span>
                          </th>
                          <th className="text-center px-2 py-4 text-[#7B7B7B] text-sm whitespace-nowrap">
                            <span className="flex items-center gap-[1px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M4.66667 6.00667L4.67333 5.99933M7.33333 6.00667L7.34 5.99933M4.66667 8.67333L4.67333 8.666M7.33333 8.67333L7.34 8.666M4.66667 11.34L4.67333 11.3327M7.33333 11.34L7.34 11.3327M10 14H2.4C2.29391 14 2.19217 13.9579 2.11716 13.8828C2.04214 13.8078 2 13.7061 2 13.6V3.73333C2 3.62725 2.04214 3.52551 2.11716 3.45049C2.19217 3.37548 2.29391 3.33333 2.4 3.33333H6V2.4C6 2.29391 6.04214 2.19217 6.11716 2.11716C6.19217 2.04214 6.29391 2 6.4 2H9.6C9.70609 2 9.80783 2.04214 9.88284 2.11716C9.95786 2.19217 10 2.29391 10 2.4V6M10 14H13.6C13.7061 14 13.8078 13.9579 13.8828 13.8828C13.9579 13.8078 14 13.7061 14 13.6V6.4C14 6.29391 13.9579 6.19217 13.8828 6.11716C13.8078 6.04214 13.7061 6 13.6 6H10M10 14V11.3333M10 6V8.66667M10 11.3333V8.66667M10 11.3333H11.3333M10 8.66667H11.3333"
                                  stroke="#7B7B7B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <span className="text-[#7B7B7B] text-sm"></span>
                              City
                            </span>
                          </th>
                          <th className="text-center px-2 py-4 text-[#7B7B7B] text-sm">
                            <span className="flex items-center gap-[1px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_180_45189)">
                                  <path
                                    d="M3.40039 0.78125C2.99414 0.78125 2.55508 0.993125 2.22414 1.32375C1.96883 1.57938 1.7857 1.89906 1.71477 2.21875H4.94414L4.22539 0.78125H3.40039ZM12.5754 0.78125L11.8566 2.21875H15.0848C15.016 1.89906 14.8316 1.57938 14.5754 1.32375C14.2473 0.993125 13.8066 0.78125 13.4004 0.78125H12.5754ZM11.716 1.23906C10.9254 1.2875 10.1598 1.43125 9.52539 1.74844C9.04727 1.98656 8.65039 2.34063 8.40039 2.81063C8.15039 2.34063 7.75352 1.98656 7.27539 1.74844C6.64102 1.43125 5.87539 1.28781 5.08477 1.23937L5.38164 1.82969C6.00039 1.89406 6.57539 2.02625 7.02539 2.25156C7.70664 2.59313 8.11914 3.09375 8.11914 4V11.2188H8.68164V4C8.68164 3.09375 9.09414 2.59313 9.77539 2.25156C10.2285 2.02594 10.8004 1.89375 11.4191 1.82938L11.716 1.23906ZM1.87977 2.78125L0.994141 4.1L2.48789 3.41563L2.20664 5.5L3.23477 3.6625L3.64727 6.34375L4.10977 3.55312L5.56914 5.3875L4.87852 3.2125L6.47852 3.6375L5.50664 2.78125H1.87977ZM11.2941 2.78125L10.3223 3.6375L11.9223 3.2125L11.2316 5.3875L12.691 3.55312L13.1535 6.34375L13.566 3.6625L14.5941 5.5L14.3129 3.41563L15.8066 4.1L14.9223 2.78125H11.2941ZM7.79727 11.7812L7.69102 15.2188H9.10977L9.00352 11.7812H7.79727Z"
                                    fill="#7B7B7B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_180_45189">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(0.400391)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className=" text-[#7B7B7B] text-sm"></span>
                              Street
                            </span>
                          </th>
                          <th className="text-center px-2 py-4 text-[#7B7B7B] text-sm ">
                            <span className="flex items-center gap-[1px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_180_45199)">
                                  <path
                                    d="M8.30049 0C5.64961 0 3.50049 2.12992 3.50049 4.75712C3.50049 7.38432 8.30049 16.0003 8.30049 16.0003C8.30049 16.0003 13.1005 7.38464 13.1005 4.75712C13.1005 2.1296 10.9514 0 8.30049 0ZM8.28481 6.17984C7.46657 6.17984 6.80353 5.52224 6.80353 4.71168C6.80353 3.90048 7.46657 3.2432 8.28481 3.2432C9.10369 3.2432 9.76673 3.90048 9.76673 4.71168C9.76673 5.52224 9.10369 6.17984 8.28481 6.17984Z"
                                    fill="#7B7B7B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_180_45199">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(0.300293)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#7B7B7B] text-sm gap-[1px]"></span>
                              Zip Code
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-none">
                          <td className="px-2 py-4 border-none text-center">
                            {addr.country}
                          </td>
                          <td className="px-2 py-4 border-none text-center">
                            {addr.state}
                          </td>
                          <td className="px-2 py-4 border-none text-center">
                            {addr.city}
                          </td>
                          <td className="px-2 py-4 border-none text-center">
                            {addr.street}
                          </td>
                          <td className="px-2 py-4 border-none text-center">
                            {addr.zip_01}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>

              <div className="flex flex-col justify-start items-start mt-8 w-full">
                <span className="text-[#1D2739] text-base font-bold flex mb-2">
                  Social Media
                </span>
                <div className="space-y-2 w-full border rounded">
                  {supplier?.socialMedia?.map((media) => (
                    <div
                      key={media.name}
                      className="flex items-center px-4 py-2 w-full text-[#757575]"
                    >
                      <div className="flex items-center gap-1 mr-6">
                        {getIcon(media.name)}
                        <span className="text-sm">{media.name}</span>
                      </div>
                      <a
                        href={media.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-[#757575] text-left break-all flex-1"
                      >
                        {media.url}
                      </a>
                      <button
                        onClick={() => handleCopy(media.url)}
                        className="text-[#757575] hover:text-black whitespace-nowrap flex items-center"
                        title="Copy URL"
                      >
                        <span className="text-sm">
                          {copied === media.url ? "Copied!" : "Copy"}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          className="ml-2"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.33301 7.77838C1.33301 7.17723 1.57182 6.60069 1.9969 6.17561C2.42198 5.75053 2.99852 5.51172 3.59967 5.51172H5.06967V6.84505H3.59967C3.35214 6.84505 3.11474 6.94339 2.93971 7.11842C2.76467 7.29345 2.66634 7.53085 2.66634 7.77838V12.5784C2.66634 12.8259 2.76467 13.0633 2.93971 13.2384C3.11474 13.4134 3.35214 13.5117 3.59967 13.5117H8.39967C8.64721 13.5117 8.88461 13.4134 9.05964 13.2384C9.23467 13.0633 9.33301 12.8259 9.33301 12.5784V11.3784H10.6663V12.5784C10.6663 13.1795 10.4275 13.7561 10.0024 14.1812C9.57737 14.6062 9.00083 14.8451 8.39967 14.8451H3.59967C2.99852 14.8451 2.42198 14.6062 1.9969 14.1812C1.57182 13.7561 1.33301 13.1795 1.33301 12.5784V7.77838Z"
                            fill="#7B7B7B"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.66667 2H12C12.7072 2 13.3855 2.28095 13.8856 2.78105C14.3857 3.28115 14.6667 3.95942 14.6667 4.66667V10C14.6667 10.7072 14.3857 11.3855 13.8856 11.8856C13.3855 12.3857 12.7072 12.6667 12 12.6667H6.66667C5.95942 12.6667 5.28115 12.3857 4.78105 11.8856C4.28095 11.3855 4 10.7072 4 10V4.66667C4 3.95942 4.28095 3.28115 4.78105 2.78105C5.28115 2.28095 5.95942 2 6.66667 2ZM6.66667 3.33333C6.31304 3.33333 5.97391 3.47381 5.72386 3.72386C5.47381 3.97391 5.33333 4.31304 5.33333 4.66667V10C5.33333 10.3536 5.47381 10.6928 5.72386 10.9428C5.97391 11.1929 6.31304 11.3333 6.66667 11.3333H12C12.3536 11.3333 12.6928 11.1929 12.9428 10.9428C13.1929 10.6928 13.3333 10.3536 13.3333 10V4.66667C13.3333 4.31304 13.1929 3.97391 12.9428 3.72386C12.6928 3.47381 12.3536 3.33333 12 3.33333H6.66667Z"
                            fill="#7B7B7B"
                          />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
          {selectedTab === "identifiers" &&
            (() => {
              const grouped = supplier?.identifiers?.identifierDetails?.reduce(
                (acc, item) => {
                  if (!item.name) return acc;
                  if (!acc[item.name]) acc[item.name] = [];
                  acc[item.name].push(item.code);
                  return acc;
                },
                {}
              );

              return (
                grouped &&
                Object.entries(grouped).map(([type, codes], index) => (
                  <div key={index} className="flex items-baseline mb-2">
                    <span className="text-sm font-[500] text-[#7B7B7B] mr-2 min-w-[80px]">
                      {type}:
                    </span>
                    <span
                      className={`mb-8 text-sm font-[500] text-[#1C1C1C] ${
                        !management && type !== "NAICS" ? "blur-[3.5px]" : ""
                      }`}
                    >
                      {codes.join(", ")}
                    </span>
                  </div>
                ))
              );
            })()}

          {selectedTab === "capabilities" &&
            supplier.capability?.capabilityDetails?.length > 0 && (
              <div>
                <p className="text-[#7B7B7B] font-lato text-sm font-normal leading-[20px]">
                  {supplier?.capability?.capabilityDetails?.[0]?.description}
                </p>
              </div>
            )}

          {selectedTab === "reviews" && <Reviews />}

          {selectedTab === "certifications" && (
            <div>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-[#FAFAFA] text-xs text-[#757575] whitespace-nowrap">
                  <tr>
                    <th className="px-4 py-2 text-left text-[13px] text-[#757575]">
                      Certificate
                    </th>
                    <th className="px-4 py-2 text-left text-[13px] text-[#757575]">
                      Date Issued
                    </th>
                    <th className="px-4 py-2 text-left text-[13px] text-[#757575]">
                      Exp Date
                    </th>
                    <th className="px-4 py-2 text-left text-[13px] text-[#757575]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200 text-xs text-[#757575]">
                  {supplier?.diversity?.certificationType?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td className="p-2 flex items-center justify-start border-none text-[13px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <path
                              d="M8.66797 21.25H17.084C18.0122 21.25 18.9025 20.8813 19.5588 20.2249C20.2152 19.5685 20.584 18.6783 20.584 17.75V12.22C20.5843 11.2919 20.216 10.4016 19.56 9.745L13.591 3.775C13.2659 3.45 12.8801 3.19221 12.4554 3.01634C12.0308 2.84047 11.5756 2.74997 11.116 2.75H8.66797C7.73971 2.75 6.84947 3.11875 6.1931 3.77513C5.53672 4.4315 5.16797 5.32174 5.16797 6.25V17.75C5.16797 18.6783 5.53672 19.5685 6.1931 20.2249C6.84947 20.8813 7.73971 21.25 8.66797 21.25Z"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.5645 3.10938V8.76938C12.5645 9.29981 12.7752 9.80852 13.1502 10.1836C13.5253 10.5587 14.034 10.7694 14.5645 10.7694H20.2265"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.125 16.5V15.5M8.125 15.5V13.5H9.125C9.39022 13.5 9.64457 13.6054 9.83211 13.7929C10.0196 13.9804 10.125 14.2348 10.125 14.5C10.125 14.7652 10.0196 15.0196 9.83211 15.2071C9.64457 15.3946 9.39022 15.5 9.125 15.5H8.125ZM16.125 16.5V15.25M16.125 15.25V13.5H17.625M16.125 15.25H17.625M12.125 16.5V13.5H12.625C13.0228 13.5 13.4044 13.658 13.6857 13.9393C13.967 14.2206 14.125 14.6022 14.125 15C14.125 15.3978 13.967 15.7794 13.6857 16.0607C13.4044 16.342 13.0228 16.5 12.625 16.5H12.125Z"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="ml-1">{item?.classification}</span>
                        </td>

                        <td className="p-2 border-none">
                          {item?.certifiedSince || ""}
                        </td>
                        <td className="p-2 border-none">
                          {item?.renewalDate || ""}
                        </td>
                        <td className="relative p-2 border-none left-4">
                          <button
                            onClick={() => toggleMenu(index)}
                            className="p-1"
                          >
                            <MoreHorizontal className="w-5 h-5" />
                          </button>
                          {openMenuIndex === index && (
                            <div
                              style={{ zIndex: "9999" }}
                              className="absolute z-10 bg-white shadow-lg border rounded-md mt-1 right-4 w-32"
                            >
                              <button
                                className="block w-full text-left px-4 py-2"
                                onClick={() => setPreviewItem(item)}
                              >
                                Preview
                              </button>
                              <button
                                className="block w-full text-left px-4 py-2"
                                onClick={() => handleDownload(item)}
                              >
                                Download
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {previewItem && (
          <>
            <Overlay />
            <PreviewPopup
              file={previewItem}
              onClose={() => setPreviewItem(null)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default UserProfileComponent;
